module.exports = __webpack_public_path__ + "img/bureaucrat.4990cb73.png";